import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSettingsPaynowOptions,
  initializeSettingsPaynowOptionsScreen,
  setDeleteConfirmationPopupVisibility,
  exportSettingsPaynowOptions,
  deleteSettingsPaynowOptions,
  savePaynowOptionsTableState,
} from "../../../redux/actions/Settings/SettingsPaynowOptions";
import SettingsPaynowOptions from '../../../component/Settings/SettingsPaynowOptions';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function SettingsPaynowOptionsScreen(props) {
  const {
    fetchSettingsPaynowOptions,
    initSettingsPaynowOptionsScreen,
    showPageLevelLoader,
    SettingsPaynowOptionsListview,
    paginationInfo,
    screenPermissions,
    exportSettingsPaynowOptions,
    isSettingsPaynowOptionsExportError,
    isSettingsPaynowOptionsExportSuccess,
    isLoading,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    deleteSettingsPaynowOptions,
    savedTableState,
    savePaynowOptionsTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initSettingsPaynowOptionsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchSettingsPaynowOptions(savedParams);
    } else {
      fetchSettingsPaynowOptions({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchSettingsPaynowOptions(newProps);
  };

  const handleTableStateChange = (tableState) => {
    savePaynowOptionsTableState(tableState);
  };

  const handleCreateSettingsPaynowOptions = () => {
    navigate(APP_URLS.SETTINGS_PAYNOWOPTIONS.CREATE);
  }
  const editSettingsPaynowOptionsRoute = (id) => {
    const path = generatePath(APP_URLS.SETTINGS_PAYNOWOPTIONS.EDIT, {
      id,
    });
    navigate(path);
  };
  const SettingsPaynowOptionsProps = {
    handleCreateSettingsPaynowOptions,
    exportSettingsPaynowOptions,
    isSettingsPaynowOptionsExportError,
    isSettingsPaynowOptionsExportSuccess,
    editSettingsPaynowOptionsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    fetchSettingsPaynowOptionss: loadLazyData,
    deleteSettingsPaynowOptions,
    tableData: {
      columns: SettingsPaynowOptionsListview?.columns,
      rows: SettingsPaynowOptionsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <SettingsPaynowOptions
        {...SettingsPaynowOptionsProps}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initSettingsPaynowOptionsScreen: () => dispatch(initializeSettingsPaynowOptionsScreen()),
    fetchSettingsPaynowOptions: (payload) => dispatch(fetchSettingsPaynowOptions(payload)),
    deleteSettingsPaynowOptions: (payload) => dispatch(deleteSettingsPaynowOptions(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportSettingsPaynowOptions: (payload) => dispatch(exportSettingsPaynowOptions(payload)),
    savePaynowOptionsTableState: (payload) => dispatch(savePaynowOptionsTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isSettingsPaynowOptionsCreateSuccess: selectFromSettingsPaynowOptionsReducer(
      state,
      "isSettingsPaynowOptionsCreateSuccess"
    ),
    SettingsPaynowOptionsListview: selectFromSettingsPaynowOptionsReducer(
      state,
      "SettingsPaynowOptionsListview"
    ),
    showPageLevelLoader: selectFromSettingsPaynowOptionsReducer(
      state,
      "showPageLevelLoader"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromSettingsPaynowOptionsReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    paginationInfo: selectFromSettingsPaynowOptionsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromSettingsPaynowOptionsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromSettingsPaynowOptionsReducer(
      state,
      "isFetchingGridData"
    ),
    isSettingsPaynowOptionsExportError: selectFromSettingsPaynowOptionsReducer(
      state,
      "isSettingsPaynowOptionsExportError"
    ),
    isSettingsPaynowOptionsExportSuccess: selectFromSettingsPaynowOptionsReducer(
      state,
      "isSettingsPaynowOptionsExportSuccess"
    ),
    savedTableState: selectFromSettingsPaynowOptionsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromSettingsPaynowOptionsReducer = (state, path) => {
  return selectSettingsPaynowOptionsReducer(state)[path];
};

const selectSettingsPaynowOptionsReducer = ({ SettingsPaynowOptionsReducer }) => {
  return SettingsPaynowOptionsReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(SettingsPaynowOptionsScreen);
